import { CheckIcon } from '@heroicons/react/16/solid';
import clsx from 'clsx';
import { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react';

import { Field } from './field';
import { Hint } from './hint';

export const Checkbox = ({
	label,
	hint,
	invalid,
	className,
	...props
}: DetailedHTMLProps<
	InputHTMLAttributes<HTMLInputElement>,
	HTMLInputElement
> & {
	label?: ReactNode;
	hint?: string;
	invalid?: boolean;
	labelSize?: 'xs' | 'sm';
}) => {
	const cn = clsx(
		{
			'text-red ring-2 ring-red': invalid,
		},
		'peer size-5 cursor-pointer appearance-none rounded bg-white ring ring-1 ring-inset ring-gray-4 checked:bg-accent checked:ring-accent',
		className,
	);
	const labelClassName = clsx('text-black', {
		'text-xs/[18px]': props.labelSize === 'xs',
		'text-sm': !props.labelSize || props.labelSize === 'sm',
	});
	return (
		<Field>
			<label className="flex cursor-pointer items-start gap-x-2">
				<span className="relative flex items-center">
					<input type="checkbox" className={cn} {...props} />
					<CheckIcon className="pointer-events-none absolute left-1/2 top-1/2 size-full -translate-x-1/2 -translate-y-1/2 transform text-white opacity-0 peer-checked:opacity-100" />
				</span>
				{label && <span className={labelClassName}>{label}</span>}
			</label>
			{hint && <Hint>{hint}</Hint>}
		</Field>
	);
};
